import { FormattedMessage, useIntl } from 'react-intl';
import { H4, IconSpinner, ListingCard, Page, PrimaryButton } from '../../components';
import { useConfiguration } from '../../context/configurationContext';
import { compose } from 'redux';
import TopbarContainer from '../TopbarContainer/TopbarContainer';
import { withRouter } from 'react-router-dom/cjs/react-router-dom';
import { connect } from 'react-redux';
import SectionContainer from '../PageBuilder/SectionBuilder/SectionContainer';
import css from './WishlistPage.module.css';
import FooterComponent from '../FooterContainer/FooterContainer';
import { addToLikeList, incrementCartCount } from '../../ducks/user.duck';
import { addListingToCart, fetchLikesListings } from './WishlistPage.duck';
import SortBy from '../SearchPage/SortBy/SortBy';
import { useMemo, useEffect, useState } from 'react';
import { useRouteConfiguration } from '../../context/routeConfigurationContext';
import { createResourceLocatorString } from '../../util/routes';
import InfiniteScroll from 'react-infinite-scroll-component';
import BackButton from '../../components/Button/BackButton';
import classNames from 'classnames';
import empty_wish from '../../assets/empty_wishlist.png';

const FILTER_DROPDOWN_OFFSET = -14;

const WishlistPageComponent = props => {
  const {
    listings,
    history,
    onAddList,
    onFetchListing,
    fetchInProgress,
    fetchError,
    totalListings,
    page,
    hasMore,
    listingsInCart,
    onAddListingToCart,
    onAddOneUserCartCount,
    userCartCount,
  } = props;

  const intl = useIntl();
  const config = useConfiguration();
  const routes = useRouteConfiguration();
  const { sortConfig } = config.search;

  const queryParams = useMemo(() => {
    return Object.fromEntries(new URLSearchParams(location.search));
  }, [location.search]);

  const currentSort = queryParams?.[sortConfig.queryParamName] || 'createdAt';

  const handleSortBy = (urlParam, value) => {
    const newQueryParams = value ? { [urlParam]: value } : {};
    history.push({
      pathname: location.pathname,
      search: new URLSearchParams(newQueryParams).toString(),
    });
    // fetch first page on sort change
    onFetchListing({ sort: value, page: 1, append: false, config });
  };

  useEffect(() => {
    onFetchListing({ sort: currentSort, page: 1, append: false, config });
  }, [currentSort]);

  const fetchMore = () => {
    if (!fetchInProgress) {
      onFetchListing({ sort: currentSort, page: page + 1, append: true, config });
    }
  };

  return (
    <Page title={intl.formatMessage({ id: 'WishlistPage.schemaTitle' })}>
      <TopbarContainer />
      <div className={css.mainContainer} role="main">
        <SectionContainer className={css.mainSection}>
          <div
            className={classNames(css.headerCont, { [css.hideForNoListings]: totalListings === 0 })}
          >
            <H4 as="h1" className={css.heading}>
              <div className={css.backBtnContainer}>
                <BackButton />
              </div>
              {totalListings !== 0 && (
                <FormattedMessage id="WishlistPage.pageHeader" values={{ count: totalListings }} />
              )}
            </H4>
            {totalListings !== 0 && (
              <div className={css.sortCont}>
                <span className={css.sortyBy}>
                  <FormattedMessage id="MainPanelHeader.sortBy" />
                </span>
                <SortBy
                  className={css.sort}
                  sort={currentSort}
                  selectedFilters={queryParams}
                  onSelect={handleSortBy}
                  showAsPopup
                  mode="desktop"
                  contentPlacementOffset={FILTER_DROPDOWN_OFFSET}
                  removeRelevance
                />
              </div>
            )}
          </div>

          {fetchError ? (
            <span className={css.errorText}>
              {intl.formatMessage({ id: 'WishlistPage.errorText' })}
            </span>
          ) : fetchInProgress ? (
            <div className={css.spinnerContainer}>
              <IconSpinner rootClassName={css.spinner} />
            </div>
          ) : listings.length === 0 && !fetchInProgress ? (
            <div className={css.emptyState}>
              <p>
                <FormattedMessage id="WishlistPage.notFoundText1" />
                <FormattedMessage id="WishlistPage.notFoundText2" />
              </p>
              <img
                className={css.emptyImage}
                src={empty_wish}
                alt="clothes hanger image illustration"
                loading="lazy"
              />
              <PrimaryButton
                onClick={() =>
                  history.push(createResourceLocatorString('SearchPage', routes, {}, {}))
                }
                className={css.btn}
              >
                {intl.formatMessage({ id: 'WishlistPage.ctaButtonText' }).toUpperCase()}
              </PrimaryButton>
            </div>
          ) : (
            <InfiniteScroll
              className={css.infiniteScroll}
              dataLength={listings.length}
              next={fetchMore}
              hasMore={hasMore}
              loader={
                <div className={css.spinnerContainer}>
                  <IconSpinner rootClassName={css.spinner} />
                </div>
              }
              endMessage={
                // <p className={css.endMessage}>
                //   <FormattedMessage id="WishlistPage.noMoreText" />
                // </p>
                <PrimaryButton
                  className={css.endBtn}
                  onClick={() =>
                    history.push(createResourceLocatorString('SearchPage', routes, {}, {}))
                  }
                >
                  {intl.formatMessage({ id: 'WishlistPage.endCtaBtn' }).toUpperCase()}
                </PrimaryButton>
              }
            >
              <div className={css.listingCardGrid}>
                {listings.map(listing => {
                  const isAddedInCart = listingsInCart?.has(listing.id.uuid);
                  // console.log(1111, listing);
                  return (
                    <ListingCard
                      key={listing.id.uuid}
                      rootClassName={css.indivCard}
                      listing={listing}
                      history={history}
                      showDelete
                      showAuthorInfo={false}
                      showProfileUrl
                      showListingName={false}
                      onAddList={onAddList}
                      showAddToCart={true}
                      handleCart={onAddListingToCart}
                      isAddedInCart={isAddedInCart}
                      totalItemsInCart={userCartCount || 0}
                      onAddOneUserCartCount={onAddOneUserCartCount}
                      onFetchListing={onFetchListing}
                      currentSort={currentSort}
                    />
                  );
                })}
              </div>
            </InfiniteScroll>
          )}
        </SectionContainer>
      </div>
      <FooterComponent />
    </Page>
  );
};

const mapStateToProps = state => {
  const {
    listings,
    fetchInProgress,
    fetchError,
    total,
    page,
    hasMore,
    listingsInCart,
  } = state.WishlistPage;

  const { currentUserCartCount } = state.user;
  return {
    listings,
    fetchInProgress,
    fetchError,
    totalListings: total,
    page,
    hasMore,
    userCartCount: currentUserCartCount,
    listingsInCart,
  };
};

const mapDispatchToProps = dispatch => ({
  onAddList: (listingId, authorId) => dispatch(addToLikeList(listingId, authorId)),
  onFetchListing: params => dispatch(fetchLikesListings(params)),
  onAddOneUserCartCount: () => dispatch(incrementCartCount()),
  onAddListingToCart: (listingId, authorId) => dispatch(addListingToCart(listingId, authorId)),
});

const WishlistPage = compose(
  withRouter,
  connect(mapStateToProps, mapDispatchToProps)
)(WishlistPageComponent);

export default WishlistPage;
